export const dashboardFr = {
  title: "Tableau de bord",
  view_label: "Vue du tableau de bord",
  view_me: "Moi",
  view_team: "Équipe",
  kpi: {
    dials_today: "Appels aujourd'hui",
    contacts_today: "Contacts aujourd'hui",
    demos_week: "Démos cette semaine",
    callbacks_due: "Rappels dus",
    overdue_count: "%{smart_count} en retard |||| %{smart_count} en retard",
    tasks_overdue: "Tâches en retard",
    team_dials: "Appels",
    team_contacts: "Contacts",
    contact_rate: "Taux de contact",
    team_demos: "Démos",
    pipeline_value: "Valeur du pipeline",
    weighted: "Pondéré : %{amount}",
    won_month: "Gagné ce mois-ci",
  },
  ready_to_call: "Prêt à appeler ?",
  start_calling: "Commencer à appeler",
  queue_size: "%{size} dans la file",
  callbacks_title: "Mes rappels d'aujourd'hui",
  no_callbacks: "Aucun rappel aujourd'hui 🎉",
  overdue: "en retard",
  call: "Appeler",
  call_company: "Appeler %{name}",
  // GAVION off-CRM call: a callback made from a cell
  off_crm: "Fait hors CRM",
  off_crm_company: "Inscrire un appel fait hors CRM à %{name}",
  demos_title: "Mes démos à venir",
  no_demos: "Aucune démo dans les 7 prochains jours.",
  my_activity: "Mon activité (14 jours)",
  dials: "Appels",
  contacts: "Contacts",
  sparkline_aria: "%{label} : %{total} sur %{days} jours",
  leaderboard: {
    title: "Classement des représentants",
    rep: "Représentant",
    dials: "Appels",
    contacts: "Contacts",
    demos: "Démos",
    talk_time: "Temps de parole",
    dials_per_hour: "Appels / h en session",
    empty: "Aucun appel aujourd'hui.",
  },
  funnel_title: "Entonnoir du mois",
  funnel_empty: "Aucun deal créé ce mois-ci.",
  funnel_link: "Voir le rapport complet",
  health: {
    title: "Intégrations",
    all_ok: "Tout fonctionne",
    levels: { warn: "à vérifier", error: "en erreur" },
    providers: {
      microsoft: "Microsoft 365",
      granola: "Granola",
      voipms: "VoIP.ms",
      ses: "Courriels (SES)",
    },
  },
};
